export const getObjectSelectedFields = ({
    account_selected: accountSelected,
    client_selected: clientSelected,
}) => ((accountSelected && accountSelected.selected) ? {
    ...accountSelected,
    isAccount: true,
    entity: 'account',
} : {
    ...clientSelected,
    isAccount: false,
    content_type_name: 'client',
    entity: 'company',
});

export const getTypeOfSelectedObject = (objectSelected) => {
    const { isAccount } = getObjectSelectedFields(objectSelected);
    return isAccount ? 'accounts' : 'clients';
};

export const isObjectSelectedMocked = (objectSelected) => {
    /* eslint-disable camelcase */
    const { is_mocked } = getObjectSelectedFields(objectSelected);

    return is_mocked;
    /* eslint-enable camelcase */
};
